'use strict';

var ascii_A = 65;
var regionalIndictor_A = 56806;

function charCodeToRegionalIndicatorCode(charCode) {
  charCode -= ascii_A;
  if (charCode < 0 || charCode > 25) throw new Error("Bad ASCII");
  return String.fromCharCode(55356, regionalIndictor_A + charCode);
}

function countryCodeToFlag(countryCode) {
  if (countryCode.length != 2) throw new Error("len≠2");
  countryCode = countryCode.toUpperCase();
  return charCodeToRegionalIndicatorCode(countryCode.charCodeAt(0)) + charCodeToRegionalIndicatorCode(countryCode.charCodeAt(1));
}

module.exports = countryCodeToFlag;